import script from "./ButtonsAuth.vue?vue&type=script&lang=ts&setup=true"
export * from "./ButtonsAuth.vue?vue&type=script&lang=ts&setup=true"

import "./ButtonsAuth.vue?vue&type=style&index=0&id=6e3e495e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e3e495e"]])

export default __exports__